import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import ContactSearcher from 'src/components/ContactSearcher'

import AddDevicesDialog from './AddDevicesDialog'
import ConfirmStatusAlertPropagate from './ConfirmStatusAlertPropagate'
import DeleteActionDialog from './DeleteActionDialog'
import AddActivityDialog from './AddActivityDialog'
import AddDecisionDialog from './AddDecisionDialog'
import AddIssueDialog from './AddIssueDialog'
import MoveActionDialog from './MoveActionDialog'
import ParentsDialog from './ParentsDialog'
import RefreshCmdbDialog from './RefreshCmdbDialog'
import SolutionDialog from './SolutionDialog'
import UnderlyingCiAlert from './UnderlyingCiAlert'
import {
    getRunbook,
    createDecisionLog,
    createIssueLog,
    createActivityLog,
} from 'src/store/modules/runbooks'
import { addCommentToAction } from 'src/store/modules/runbooks/actions'
import {
    toggleControl,
    singleEditAction,
} from 'src/store/modules/ui/runbook/controls'
import AddOrEditActionDialog from './AddOrEditActionDialog'

class Dialogs extends Component {
    handleInsertDecisionClose = () => {
        const { actions } = this.props

        actions.singleEditAction(null)
        actions.toggleControl('isInsertingDecision')
    }

    handleInsertIssueClose = () => {
        const { actions } = this.props

        actions.singleEditAction(null)
        actions.toggleControl('isInsertingIssue')
    }

    handleInsertActivityClose = () => {
        const { actions } = this.props

        actions.singleEditAction(null)
        actions.toggleControl('isInsertingActivity')
    }

    render() {
        const {
            runbook,
            isInsertingActionAsSibling,
            isInsertingActionAsChild,
            isInsertingActivity,
            isInsertingDecision,
            singleOpenAction,
            isInsertingIssue,
            isMovingAction,
            isRefreshingCmdb,
            isEditingBaseFields,
            actions,
        } = this.props

        return (
            <>
                <SolutionDialog />
                <ContactSearcher runbookId={runbook.id} />
                <ConfirmStatusAlertPropagate />
                <AddDevicesDialog />
                <DeleteActionDialog />
                {(isEditingBaseFields ||
                    isInsertingActionAsSibling ||
                    isInsertingActionAsChild) && <AddOrEditActionDialog />}
                {isInsertingDecision && (
                    <AddDecisionDialog
                        fromAction={singleOpenAction}
                        handleClose={this.handleInsertDecisionClose}
                        handleConfirm={(data) => {
                            actions.createDecisionLog(
                                runbook.activeSession,
                                data
                            )
                        }}
                    />
                )}
                {isInsertingIssue && (
                    <AddIssueDialog
                        fromAction={singleOpenAction}
                        handleClose={this.handleInsertIssueClose}
                        handleConfirm={(data) =>
                            actions.createIssueLog(runbook.activeSession, data)
                        }
                    />
                )}
                {isInsertingActivity && (
                    <AddActivityDialog
                        fromAction={singleOpenAction}
                        handleClose={this.handleInsertActivityClose}
                        handleConfirm={(data) => {
                            actions.createActivityLog(
                                runbook.activeSession,
                                data
                            )
                        }}
                    />
                )}
                {isMovingAction && (
                    <MoveActionDialog
                        runbookId={runbook.id}
                        handleClose={() =>
                            actions.toggleControl('isMovingAction')
                        }
                    />
                )}
                {isRefreshingCmdb && (
                    <RefreshCmdbDialog runbookId={runbook.id} />
                )}
                <ParentsDialog />
                <UnderlyingCiAlert />
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    runbook: getRunbook(state, state.ui.runbook.activeRunbook),
    singleOpenAction: state.ui.runbook.controls.singleOpenAction,
    isInsertingDecision: state.ui.runbook.controls.isInsertingDecision,
    isInsertingIssue: state.ui.runbook.controls.isInsertingIssue,
    isInsertingActivity: state.ui.runbook.controls.isInsertingActivity,
    isMovingAction: state.ui.runbook.controls.isMovingAction,
    isRefreshingCmdb: state.ui.runbook.controls.isRefreshingCmdb,
    isEditingBaseFields: state.ui.runbook.controls.isEditingBaseFields,
    isInsertingActionAsSibling:
        state.ui.runbook.controls.isInsertingActionAsSibling,
    isInsertingActionAsChild:
        state.ui.runbook.controls.isInsertingActionAsChild,
})

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
        actions: bindActionCreators(
            {
                addCommentToAction,
                createActivityLog,
                createDecisionLog,
                createIssueLog,
                singleEditAction,
                toggleControl,
            },
            dispatch
        ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dialogs)
